export default __webpack_public_path__ + "static/media/image-check-filled-lime.bbb92804.svg";